import { SegmentAnalysisModule } from "@/features/segment-analysis/components/segment-analysis-module"

export function SegmentAnalysisPage() {
  return <SegmentAnalysisModule />
}
